<template>
    <v-container>
      <h1 class="titulo mb-3">Configuração de Grandes Negócios</h1>
        <v-card class="card">
            <v-card-text>
                <v-form ref="formGrandesNegocios" @submit.prevent>
                  <v-row class="d-flex justify-space-between flex-wrap align-center mt-4">
                    <v-col cols="10" md="8" class="mr-12">
                      <label class="text--primary label-style mb-4 d-inline-block">Valor de Grande Negócio: </label>
                      <MoneyTextField
                            class="money-input"
                            label=""
                            placeholder="Digite o valor que deverá ser considerado um grande negócio"
                            outlined
                            :rules="[$rules.required]"
                            v-model="valor_grande_negocio"
                            maxvalue="999999999.99"
                      />
                    </v-col>
                    <v-col cols="2">
                      <v-btn class="transition" color="primary" rounded @click="salvarConfiguracao">
                        Salvar
                    </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="8" md="6">
                      <HintMessage style="max-width: 550px;" class="mt-8 mb-6" title="DICA PARA CONFIGURAÇÃO"
                                         icon="mdi-lightbulb-on-outline" icon-color="secondary"
                                         description="<p>O valor se refere ao <strong>total do saldo devedor</strong>, não se limitando apenas às novas cotas adquiridas. <p>Exemplo: Um consosrciado com três cotas de R$ 1 milhão <strong>(R$ 3 milhões de saldo devedor)</strong> que adquire mais uma cota de <strong>R$ 1 milhão</strong>, será classificado <strong>como cliente de grandes negócios.</strong></p>"
                                         :description-html="true"
                                         :center-icon="false" />
                    </v-col>
                  </v-row>

                </v-form>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import { AlertTypes } from '@/plugins/alerts_types'
import { notification } from '@/plugins/helpers'

  export default {
    name: 'ConfigCreditAnalysisGrandesNegocios',
    data: () => ({
      valor_grande_negocio: null
    }),
    computed: {

    },
    async mounted () {
      await this.getConfiguracaoGrandesNegocios()
    },
    methods: {
      async salvarConfiguracao () {
        if (!this.$refs.formGrandesNegocios.validate()) {
          return
        }
        try {
          const valorGrandeNegocio = parseFloat(this.valor_grande_negocio)
          const response = await this.$http.put('/painel/grandes_negocios/salvar', { valor_grande_negocio: valorGrandeNegocio })
          if (response.data.success) {
            notification(AlertTypes.SUCCESS, response.data.message)
          }
          this.resetForm()
        } catch (error) {
           let errorMessage = error.response?.data?.error || error.message
          notification(AlertTypes.ERROR, errorMessage)
        }
      },
      async getConfiguracaoGrandesNegocios () {
        try {
          const response = await this.$http.get('/grandes_negocios')

          this.valor_grande_negocio = response.data.vl_grande_negocio
        } catch (error) {
          let errorMessage = error.response?.data?.error || error.message
          notification(AlertTypes.ERROR, errorMessage)
        }
      },
      resetForm () {
        this.$refs.formGrandesNegocios.resetValidation()
      }
    }
  }
</script>

<style scoped lang="scss">
  .label-style {
    font-size: 11px;
  }

  .money-input {
    margin-top: -1px !important;
  }
</style>
